import { combineActions, handleActions } from 'redux-actions';
import { businessModule as actions } from '../../../actions';

const initialState = {
  isFetchingId: true,
  id: '',
  name: '',
};

const businessModule = handleActions<any, any>({
  [combineActions(
    actions.getId,
    actions.receiveId,
    actions.receiveName,
  ) as any]: (state: any, action: any): any => ({
    ...state,
    ...action.payload,
  }),
}, initialState);

export default businessModule;
